import { useEffect } from "react";
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router-dom";
import { usePostHog } from "posthog-js/react";
import { init as sentryInit, reactRouterV6BrowserTracingIntegration, replayIntegration } from "@sentry/react";

const useSentry = () => {
  const posthog = usePostHog();

  useEffect(() => {
    sentryInit({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
      integrations: [
        posthog.sentryIntegration({
          organization: import.meta.env.VITE_SENTRY_ORGANIZATION,
          projectId: import.meta.env.VITE_SENTRY_PROJECT_ID,
          severityAllowList: ["error"],
        }),
        // See docs for support of different versions of variation of react router
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
        reactRouterV6BrowserTracingIntegration({
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
        replayIntegration(),
      ],

      // Reduced from 1.0 (100%) to 0.5 (50%) to avoid rate limiting
      tracesSampleRate: 0.5,

      // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
      tracePropagationTargets: [/^\//, /^https:\/\/(dev\.server\.|dev\.)api\.financeable\.com\.au/],

      // Do not require replays as we do not use that feature
      replaysSessionSampleRate: 0,
      // Do not require replays as we do not use that feature
      replaysOnErrorSampleRate: 0,
    });
  }, []);
};

export { useSentry };
